import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Options } from 'ngx-qrcode-styling';


@Component({
  selector: 'app-qr-code-description-dialog',
  templateUrl: './qr-code-description-dialog.component.html',
  styleUrls: ['./qr-code-description-dialog.component.css']
})
export class QrCodeDescriptionDialogComponent implements OnInit {

  config: Options = {
    width: 200,
    height: 200,
    data: "",
    image: "",
    margin: 5,
    backgroundOptions: {
      color: "#ffffff",
    },
    imageOptions: {
      crossOrigin: "anonymous",
      margin: 0
    }
  };

  baseUrl = "https://dkm.hybraine.com/dkm/public/?p=" ;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(){
  //this.config.data = this.baseUrl+this.data.product.id+"pp"+this.data.product.idstock;
	this.config.data = this.baseUrl+this.data.product.id+"pp"+this.data.product.idstock;
	this.config.template = "default" ;
	this.config.image = "" ;          

  }



}
